import { savePersistedFilters } from './persistListFilters';

export const ORDERS_LIST_FILTER_KEY = 'orders';
export const INVOICES_LIST_FILTER_KEY = 'invoices';

const toId = (value) => {
  if (value == null || value === '' || value === '-') {
    return null;
  }
  return value;
};

export const clientPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/clients/${resolved}` : null;
};

export const clientTabPath = (id, tab) => {
  const base = clientPath(id);
  if (!base) {
    return null;
  }
  return tab ? `${base}?tab=${encodeURIComponent(tab)}` : base;
};

export const dentistPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/dentists/${resolved}` : null;
};

export const orderPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/orders/${resolved}` : null;
};

export const invoicePath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/invoices/${resolved}` : null;
};

export const userPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/users/${resolved}` : null;
};

export const walletPath = (id) => {
  const resolved = toId(id);
  return resolved != null ? `/wallets/${resolved}` : null;
};

export const expensesPath = () => '/setting/expenses';

export const expenseTypePath = (name) => {
  const trimmed = String(name ?? '').trim();
  return trimmed ? `/setting/expense-types?name=${encodeURIComponent(trimmed)}` : null;
};

const emptyOrdersFilters = {
  search: '',
  client_id: null,
  dentist_id: null,
  technician_id: null,
  courier_id: null,
  formula_type_id: null,
  order_status: null,
  delivered: null,
  requested_at: [],
};

const emptyInvoicesFilters = {
  search: '',
  client_id: null,
  dentist_id: null,
  payment_status: null,
  created_at: [],
  draft_filter: 'non-drafts',
};

export function persistClientOrdersFilter(clientId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    client_id: Number(clientId),
  });
}

export function persistDentistOrdersFilter(dentistId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    dentist_id: Number(dentistId),
  });
}

export function persistTechnicianOrdersFilter(technicianId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    technician_id: Number(technicianId),
  });
}

export function persistCourierOrdersFilter(courierId) {
  savePersistedFilters(ORDERS_LIST_FILTER_KEY, {
    ...emptyOrdersFilters,
    courier_id: Number(courierId),
  });
}

export function persistClientInvoicesFilter(clientId) {
  savePersistedFilters(INVOICES_LIST_FILTER_KEY, {
    ...emptyInvoicesFilters,
    client_id: Number(clientId),
  });
}

export function persistDentistInvoicesFilter(dentistId) {
  savePersistedFilters(INVOICES_LIST_FILTER_KEY, {
    ...emptyInvoicesFilters,
    dentist_id: Number(dentistId),
  });
}

export function activitySubjectPath(entity, entityId) {
  const id = toId(entityId);
  if (id == null) {
    return null;
  }

  switch (String(entity || '')) {
    case 'Order':
      return orderPath(id);
    case 'Invoice':
      return invoicePath(id);
    case 'Client':
      return clientPath(id);
    case 'User':
      return userPath(id);
    case 'Wallet':
      return walletPath(id);
    default:
      return null;
  }
}

export function transactionReferencePath(record) {
  const type = record?.type;
  if (type === 'INVOICE') {
    return invoicePath(record?.invoice?.id ?? record?.invoice_id);
  }
  if (type === 'INVOICE_REFUND') {
    return invoicePath(record?.invoice?.id ?? record?.invoice_id) ?? walletPath(record?.wallet_id);
  }
  if (type === 'WALLET_RECHARGE' || type === 'WALLET_DEDUCTION' || type === 'WALLET_RECHARGE_REVERT') {
    return walletPath(record?.wallet_id);
  }
  if (type === 'EXPENSE') {
    return expensesPath();
  }
  return null;
}

export function canOpenTransactionReference(record, links) {
  const path = transactionReferencePath(record);
  if (!path) {
    return false;
  }
  if (path.startsWith('/invoices')) {
    return Boolean(links?.canOpenInvoice);
  }
  if (path.startsWith('/wallets')) {
    return Boolean(links?.canOpenWallet);
  }
  if (path.startsWith('/setting/expenses')) {
    return Boolean(links?.canOpenExpense);
  }
  return false;
}

export function canOpenActivitySubject(entity, links) {
  switch (String(entity || '')) {
    case 'Order':
      return Boolean(links?.canOpenOrder);
    case 'Invoice':
      return Boolean(links?.canOpenInvoice);
    case 'Client':
      return Boolean(links?.canOpenClient);
    case 'User':
      return Boolean(links?.canOpenUser);
    case 'Wallet':
      return Boolean(links?.canOpenWallet);
    default:
      return false;
  }
}
